import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './project.reducer';

export const selectProjectState = createFeatureSelector<State>(featureKey);

export const getProjectData = createSelector(selectProjectState, (state: State) => state.project);

export const getNonModifiedProjectData = createSelector(selectProjectState, (state: State) => state.nonModifiedProject);

export const getWrittenPartnershipCardNumber = createSelector(
  selectProjectState,
  (state: State) => state.writtenPartnershipCardNumber
);
